export function asResourceWithoutAction<T>(dto: { resource: T }): T {
    return dto.resource;
}

export function mapAsResourceWithoutAction<T>(dto: { resource: T }[]): T[] {
    return dto.map(asResourceWithoutAction);
}
